import React from 'react';
import { useReveal } from '../lib/useReveal';
const MODULES = [{
  title: 'Fundamentos del Montañismo',
  desc: 'Conocé las bases del senderismo, trekking y alta montaña para comenzar con conocimientos sólidos.'
}, {
  title: 'Preparación Física y Mental',
  desc: 'Entrená tu cuerpo y fortalecé tu mente para afrontar nuevos desafíos.'
}, {
  title: 'Equipamiento del Montañista',
  desc: 'Aprendé a elegir correctamente botas, mochila, ropa y accesorios esenciales.'
}, {
  title: 'Planificación y Seguridad',
  desc: 'Descubrí cómo preparar cada salida, interpretar el clima y minimizar riesgos.'
}, {
  title: 'Técnicas de Progresión',
  desc: 'Mejorá tu forma de caminar, ascender y descender con mayor eficiencia.'
}, {
  title: 'Tu Primera Expedición',
  desc: 'Organizá tu primera aventura aplicando todo lo aprendido.'
}];
export function HowItWorksSection() {
  const [headerRef, headerVisible] = useReveal();
  const [gridRef, gridVisible] = useReveal();
  return <section id="modules" className="border-t border-white/5 bg-[#152019] px-4 py-14 text-white md:py-20" data-id="element-150" data-mp="1i9sibfqm8j5c">
      <div className="container mx-auto max-w-5xl" data-id="element-151" data-mp="119pnk73hu4d5">
        <div ref={headerRef} className={`reveal mb-10 text-center ${headerVisible ? 'is-visible' : ''}`} data-id="element-152" data-mp="11867aghu7tbd">
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.22em] text-[#e6a45c]" data-id="element-153" data-mp="15buira9lb91w">Colección completa</p>
          <h2 className="mb-4 font-serif text-3xl font-bold leading-tight md:text-5xl" data-id="element-154" data-mp="1a8beoqn16rpj">¿Qué vas a aprender?</h2>
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-stone-400 md:text-xl" data-id="element-155" data-mp="dibws5kzqgua">Seis tomos para prepararte antes de tu primera salida y avanzar con confianza.</p>
        </div>
        <div ref={gridRef} className={`reveal grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 ${gridVisible ? 'is-visible' : ''}`} data-id="element-156" data-mp="miqkfblfg80y">
          {MODULES.map((module, index) => <article key={module.title} className="relative overflow-hidden rounded-2xl border border-[#dbe8d5]/10 bg-[#101914] p-6" data-id="element-157" data-mp="3q0sa6zquo3fe" data-mpi={index}>
            <span className="mb-4 inline-block border-b border-[#e6a45c]/50 pb-2 text-xs font-bold tracking-[0.2em] text-[#e6a45c]" data-id="element-158" data-mp="3uyk2huveprk4">TOMO 0{index + 1}</span>
            <h3 className="mb-3 font-serif text-2xl font-bold text-white" data-id="element-159" data-mp="x60hcdgkcfii">{module.title}</h3>
            <p className="text-sm leading-relaxed text-stone-400" data-id="element-160" data-mp="1axeyeeqwu6mx">{module.desc}</p>
          </article>)}
        </div>
      </div>
    </section>;
}